export default {
  buttons: {
    save: 'Guardar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  confirmation: {
    title: '¿Seguro que quieres sincronizar con los servicios externos?',
  },
};
